<template>
  <div>
    <keep-alive>
      <app-main></app-main>
    </keep-alive>
  </div>
</template>

<script>
import { appMain } from 'sgm-dms-vue-menu';

export default {
  name: 'app',
  components: {
    appMain
  }
};
</script>
